import { cloneDeep, get } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchUserAndRedirect } from '../../actions/fetch-user-and-redirect';
import { pageOpened } from '../../actions/page-opened';
import { redirectTo404 } from '../../actions/redirect-to-404';
import { updateUserSettings } from '../../actions/update-user-settings';
import NotificationsSettings from '../../components/notifications-settings';
import Page from '../../components/page';
import AppLoaded from '../../components/app-loaded';
import { USER_SETTINGS } from '../../services/detect-route';
import { getCurrentUser, getCurrentUserSettings } from '../../selectors/current-user-selectors';

export class ProfileNotificationsPage extends Component {
  static fetchData = ({ store, params, search }) => {
    return store
      .dispatch(
        fetchUserAndRedirect(params.userSlug, search, (user, search) => `/profiles/${user.slug}/settings${search}`)
      )
      .catch(() => store.dispatch(redirectTo404(search)));
  };

  static settingsNotificationsKeys = ['likes', 'comments', 'subscriptions', 'general'];

  constructor(props) {
    super(props);

    //these values are available only after component did mount
    this.changeHandlers = {
      email: this.handleEmailChange,
    };
  }

  handleEmailChange = settingKey => {
    const newValue = !this.isChecked('email', settingKey);
    const { currentUser } = this.props;
    const activeKeyName = 'email';

    const settings = cloneDeep(this.props.settings);
    settings[activeKeyName] = settings[activeKeyName] || {};
    settings[activeKeyName][settingKey] = newValue;

    return this.props.updateUserSettings(currentUser._id, settings);
  };

  handleChange = (keyName, settingsProp) => {
    return () => this.changeHandlers[keyName](settingsProp);
  }

  isChecked = (keyName, settingKey) => {
    const settings = this.props.settings[keyName];
    return get(settings, settingKey, false);
  };

  componentDidMount() {
    this.props.pageOpened({ page: USER_SETTINGS });
  }

  render() {
    const { settings } = this.props;
    return (
      <Page noSpacing>
        <NotificationsSettings
          settings={ProfileNotificationsPage.settingsNotificationsKeys}
          onChange={this.handleChange}
          isChecked={this.isChecked}
          userSettings={settings}
        />
        <AppLoaded/>
      </Page>
    );
  }
}

ProfileNotificationsPage.propTypes = {
  updateUserSettings: PropTypes.func,
  pageOpened: PropTypes.func,
  currentUser: PropTypes.object,
  settings: PropTypes.object,
};

const mapStateToProps = state => ({
  currentUser: getCurrentUser(state),
  settings: getCurrentUserSettings(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    updateUserSettings,
    pageOpened,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfileNotificationsPage);



// WEBPACK FOOTER //
// ./app/containers/profile-notifications-page/profile-notifications-page.js